import api from "../api/api";

function mapMemberItem(item) {
    const first = (item?.firstName || "").trim();
    const last = (item?.lastName || "").trim();
    const fullName = (item?.fullName || "").trim();

    return {
        id: Number(item?.memberDUID ?? 0),
        name: fullName || [first, last].filter(Boolean).join(" ") || "Unnamed Member",
        _pickerType: "member",
        memberDUID: item?.memberDUID,
        familyDUID: item?.familyDUID,
        fullName: item?.fullName,
        firstName: item?.firstName,
        lastName: item?.lastName,
        familyHomePhone: item?.family_HomePhone,
        homePhone: item?.homePhone,
        workPhone: item?.workPhone,
        mobilePhone: item?.mobilePhone,
        emailAddress: item?.emailAddress,
        recordCount: item?.recordCount,
        family_DoNotCall: item?.family_DoNotCall,
    };
}

const members = {
    load: async (search, page, pageSize, skipTotal) => {
        const parishSoftToken = localStorage.getItem("ParishSoftToken") || "";
        const result = await api.parishSoft.getMemberList(
            parishSoftToken,
            search,
            page,
            pageSize,
            skipTotal,
        );

        if (result?.success) {
            const mappedList = Array.isArray(result?.list)
                ? result.list.map(mapMemberItem)
                : [];
            const totalCount =
                typeof result?.totalCount === "number"
                    ? result.totalCount
                    : mappedList[0]?.recordCount || 0;

            return {
                success: true,
                list: mappedList,
                totalCount,
            };
        }

        return {
            success: false,
            list: [],
            totalCount: 0,
            errorMessage: result?.errorMessage || "Failed to load members.",
        };
    },
};

export default members;
